// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1kuVq","search":"Settings_search__34ba8","filter":"Settings_filter__3o2PA"};